// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerDiv {
  background: #0a0a0d;
  padding: 12px 6vw;
  position: sticky;
  top: 0;
  z-index: 10;
}

.HeadermainDivMob {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Logoclass {
  width: auto;
  height: 65px;
}

.HeaderOptionsDiv {
  display: flex;
  align-items: center;
}

.profilePictureDiv {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.profiledrpdwnDiv {
  padding: 12px;
}

.notifyDiv {
  display: flex;
  position: relative;
  margin: 0px 5px;
}

.mob_Logoclass {
    width: auto;
    height: 40px;
  }

@media (min-width: 768px) {
  .HeaderOptionsDiv {
    display: flex;
    align-items: center;
    gap: 25px;
  }
  .notifyDiv {
    display: flex;
    position: relative;
    margin: 0px 5px;
  }
  .notifitionCount {
    position: absolute;
    width: 15px;
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    background-color: #ff6464;
    color: white;
    border-radius: 50%;
    top: -10px;
    left: 20px;
    font-size: 16px;
  }

  .Loginbtn {
    width: 100px;
    height: 40px;
    background: #ffffff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px 0px 0px 5px;
    font-family: "Noto Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    border: none;
  }

  .ant-popover .ant-popover-inner {
    background-color: #16181f;
  }
  .ant-popover .ant-popover-arrow:before {
    background-color: #16181f;
  }

  .profilePictureDiv {
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .profiledrpdwnDiv {
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;EACd;;AAEF;EACE;IACE,aAAa;IACb,mBAAmB;IAInB,SAAS;EAHX;EAKA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".headerDiv {\n  background: #0a0a0d;\n  padding: 12px 6vw;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.HeadermainDivMob {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.Logoclass {\n  width: auto;\n  height: 65px;\n}\n\n.HeaderOptionsDiv {\n  display: flex;\n  align-items: center;\n}\n\n.profilePictureDiv {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n}\n\n.profiledrpdwnDiv {\n  padding: 12px;\n}\n\n.notifyDiv {\n  display: flex;\n  position: relative;\n  margin: 0px 5px;\n}\n\n.mob_Logoclass {\n    width: auto;\n    height: 40px;\n  }\n\n@media (min-width: 768px) {\n  .HeaderOptionsDiv {\n    display: flex;\n    align-items: center;\n  }\n\n  .HeaderOptionsDiv {\n    gap: 25px;\n  }\n  .notifyDiv {\n    display: flex;\n    position: relative;\n    margin: 0px 5px;\n  }\n  .notifitionCount {\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2px;\n    background-color: #ff6464;\n    color: white;\n    border-radius: 50%;\n    top: -10px;\n    left: 20px;\n    font-size: 16px;\n  }\n\n  .Loginbtn {\n    width: 100px;\n    height: 40px;\n    background: #ffffff;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0px 0px 0px 5px;\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    border: none;\n  }\n\n  .ant-popover .ant-popover-inner {\n    background-color: #16181f;\n  }\n  .ant-popover .ant-popover-arrow:before {\n    background-color: #16181f;\n  }\n\n  .profilePictureDiv {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n  }\n\n  .profiledrpdwnDiv {\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
